import React from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import { Grid } from '@fuww/library/src/Grid';

import EventDetail, {
  imageConfigurations,
} from '../components/Events/EventDetail';
import eventBySlugQuery from '../lib/queries/events/eventBySlugQuery.graphql';
import EventPage from '../lib/eventPage';
import withApollo from '../lib/apollo';

class Event extends EventPage {
  render() {
    const { router: { query: { slug } } } = this.props;

    return (
      <Grid>
        <EventDetail
          query={eventBySlugQuery}
          variables={{ slug, imageConfigurations }}
          errorMessage="Error loading this event info"
        />
      </Grid>
    );
  }
}

Event.propTypes = {
  router: PropTypes.shape({}),
};

Event.defaultProps = {
  router: {},
};

export default withApollo(withRouter(Event));
